import React from 'react';
import Icon from '../icon/Icon';
import useNotifications from '../../hooks/useNotifications';
import NotificationDrawer from './NotificationDrawer';

const bellPulseStyle = `
@keyframes bell-pulse {
    0%   { transform: scale(1); }
    50%  { transform: scale(1.18); }
    100% { transform: scale(1); }
}
.bell-has-unread {
    animation: bell-pulse 1.8s ease-in-out infinite;
}
`;

const NotificationBell = () => {
    const { notifications, unreadCount, isDrawerOpen, loading, openDrawer, closeDrawer, fetchNotifications } =
        useNotifications();

    const hasUnread = unreadCount > 0;

    return (
        <>
            <style>{bellPulseStyle}</style>

            {/* Stil din designul Transfer market 2.0 (.vtm-hdr-bell* in transfer-market.css) */}
            <button
                type='button'
                className='vtm-hdr-bell'
                onClick={openDrawer}
                aria-label={hasUnread ? `Notificări, ${unreadCount} necitite` : 'Notificări'}>
                <span className={hasUnread ? 'bell-has-unread' : undefined} style={{ display: 'inline-flex' }}>
                    <Icon icon='Notifications' style={{ fontSize: '22px' }} />
                </span>
                {hasUnread && (
                    <span className='vtm-hdr-bell-n' aria-hidden='true'>
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                )}
            </button>

            <NotificationDrawer
                isOpen={isDrawerOpen}
                onClose={closeDrawer}
                notifications={notifications}
                loading={loading}
                onRefresh={fetchNotifications}
            />
        </>
    );
};

export default NotificationBell;
